import { useEffect, useState } from 'react'

import { useAuth0 } from 'shim/auth0-react'
import useSWR from 'swr'

import { GET_USER_API_TOKENS } from '../queries'
import { GET_ACCOUNT_API_TOKENS } from '../queries'
import { consoleFetcher } from 'common/fetchers/graphql'

export interface ApiKeyType {
  id: string
  note: string
  isRevoked: boolean
  createdAt: string
  updatedAt: string
}

export default function useApiKeys(account?: string) {
  let query = GET_USER_API_TOKENS
  if (account) {
    query = GET_ACCOUNT_API_TOKENS
  }
  const { getAccessTokenSilently, isAuthenticated } = useAuth0()
  const { data, error, mutate } = useSWR(
    isAuthenticated || process.env.NEXT_PUBLIC_BYPASS_AUTH_STATE
      ? [query, { accountID: account }, { tokenFn: getAccessTokenSilently }]
      : false,
    consoleFetcher,
    { shouldRetryOnError: false }
  )
  const [apiKeysResult, setApiKeysResult] = useState<Array<ApiKeyType>>()

  useEffect(() => {
    if (data) {
      if (account) {
        setApiKeysResult(data.listAccountAPITokens.filter((apikey: ApiKeyType) => !apikey.isRevoked) as ApiKeyType[])
        return
      }
      const filteredKeys = data.userAPITokens.filter((apikey: ApiKeyType) => !apikey.isRevoked) as ApiKeyType[]
      setApiKeysResult(filteredKeys)
    }
  }, [data])

  return {
    apiKeys: apiKeysResult,
    loading: typeof data === 'undefined' && !error,
    error: error || null,
    mutate,
  }
}
